import instance from "./instance";
const responseData = response => response.data;

export function getCurrentDigitalCharitySettings() {
    return instance.request({ url: "/cms/charity/digital-settings", method: "GET" }).then(responseData);
}

export function updateDigitalCharitySettings(charityName, donationCode, additionalInfo, logoImage, webEnabled, mobileEnabled) {
    const formData = new FormData();
    if (charityName) {
        formData.append("charityName", charityName);
    }
    if (donationCode !== null) {
        formData.append("donationCode", donationCode);
    }
    if (additionalInfo) {
        formData.append("additionalInfo", additionalInfo)
    }
    if (logoImage) {
        formData.append("logoImage.image", logoImage.image);
        formData.append("logoImage[centerX]", logoImage.centerX);
        formData.append("logoImage[centerY]", logoImage.centerY);
        formData.append("logoImage[width]", logoImage.width);
        formData.append("logoImage[height]", logoImage.height);
    }
    if (webEnabled !== null) {
        formData.append("webEnabled", webEnabled)
    }
    if (mobileEnabled !== null) {
        formData.append("mobileEnabled", mobileEnabled)
    }

    return instance.request({
        url: "/cms/charity/digital-settings",
        method: "POST",
        data: formData,
    });
}

export function getCurrentPosCharitySettings() {
    return instance.request({ url: "/cms/charity/pos-settings", method: "GET" }).then(responseData);
}

export function updatePosCharitySettings(enabled, cashierPrompt, mode, rewardMinimumCents, rewardMessage) {
    const formData = new FormData();
    if (enabled !== null) {
        formData.append("enabled", enabled);
    }
    if (cashierPrompt !== null) {
        formData.append("cashierPrompt", cashierPrompt);
    }
    if (mode) {
        formData.append("mode", mode);
    }
    if (rewardMinimumCents !== null) {
        formData.append("rewardMinimumCents", rewardMinimumCents)
    }
    if (rewardMessage) {
        formData.append("rewardMessage", rewardMessage);
    }

    return instance.request({
        url: "/cms/charity/pos-settings",
        method: "POST",
        data: formData,
    });
}
